import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const SchAreaDesktop = styled.div`
  background-color: #fff;

  .inner-sch {
    ${mixin.flex({})};
    width: 360px;
    height: 40px;
    border-bottom: 1px solid #000;
  }

  .input {
    width: 100%;
    border: 0;

    input {
      font-size: 15px;
      font-weight: 500;
      line-height: 130%;
      width: 100%;

      &::-webkit-input-placeholder {
        color: #acacac;
      }
      &:-moz-placeholder {
        color: #acacac;
      }
      &::-moz-placeholder {
        color: #acacac;
      }
      &:-ms-input-placeholder {
        color: #acacac !important;
      }
      &::-ms-input-placeholder {
        color: #acacac;
      }
      &::placeholder {
        color: #acacac;
      }
    }
  }

  .btn-serach {
    margin-left: 8px;
  }

  .sch-keywordlist-desktop,
  .sch-autolist-desktop {
    position: absolute;
    top: 50px;
    right: 0;
  }
`;
